define.alias("shared/components/shared/post/secondary/caption-writer/list-item", "calendar/components/shared/post/secondary/caption-writer/list-item");